// Constants
import { licenseConfig } from "./constants";

// Precio de la licencia por terapeuta y ano. Baja de forma lineal segun crece
// el numero de terapeutas, hasta tocar maxDiscount justo en discountRange.
// Sin redondeos: se redondea solo al mostrar.
export const getLicenseUnitPrice = (yearlyFeePerTherapist, therapists) => {
  const { maxDiscount, discountRange } = licenseConfig;
  const rawDiscount = ((therapists - 1) * maxDiscount) / (discountRange - 1);
  // Protege de un tope de terapeutas mayor que el rango, que daria precios negativos.
  const volumeDiscount = Math.min(Math.max(rawDiscount, 0), maxDiscount);

  return yearlyFeePerTherapist * (1 - volumeDiscount);
};

export const getLicenseTotal = (yearlyFeePerTherapist, therapists, years) => {
  if (!therapists || !years) return 0;

  return getLicenseUnitPrice(yearlyFeePerTherapist, therapists) * therapists * years;
};

export const applyDiscount = (amount, discountPercentage) => amount * (1 - discountPercentage / 100);

export const applyTax = (amount, taxPercentage) => amount * (1 + taxPercentage / 100);

// Primero el descuento y despues los impuestos sobre la base ya descontada.
export const getFinalTotal = (amount, discountPercentage, taxPercentage) =>
  applyTax(applyDiscount(amount, discountPercentage), taxPercentage);

// La moneda la marca el distribuidor y el formato el idioma de la pantalla, asi
// que un distribuidor en dolares que mire la pagina en espanol ve 1.000 $.
export const formatCurrency = (amount, currency, locale) => {
  const options = {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    // El es-ES moderno no separa los miles hasta cinco cifras, y queremos
    // 4.208 € en vez de 4208 €. Los navegadores que no lo soporten lo ignoran.
    useGrouping: "always",
  };

  try {
    // narrowSymbol da ¥ en vez de JPY, pero no lo soportan los navegadores viejos.
    return new Intl.NumberFormat(locale, { ...options, currencyDisplay: "narrowSymbol" }).format(amount);
  } catch (error) {
    try {
      return new Intl.NumberFormat(locale, options).format(amount);
    } catch (currencyError) {
      // Una moneda que Intl no reconozca no debe tumbar la pantalla.
      console.log("Currency format: ", currencyError);
      return `${Math.round(amount * 100) / 100} ${currency}`;
    }
  }
};
